import React, { useState } from 'react'
import MainLayouts from '../../../layouts/MainLayouts'
import AgoraUIKit from 'agora-react-uikit';
import { Button } from 'antd';
import { Col, Row } from 'react-bootstrap';

function AgoraVideoCall() {

    const [videoCall, setVideoCall] = useState(true);

    const APP_ID = '400af929b16c484e93501682ab2c64cc';
    const TOKEN =
        "007eJxTYPC6fqgnaMX99DoJroPHL5ZcXsPyxf9wzmKe7nb/TddcO+4qMJgYGCSmWRpZJhmaJZtYmKRaGpsaGJpZGCUmGSWbmSQnP94pmJ4QwsBwOV+fiZGBkYEFiEF8JjDJDCZZwCQXQ2ZeZnJGYl5eag4DAwDw4yUs";
    const CHANNEL = 'inichannel';

    const rtcProps = {
        appId: APP_ID,
        channel: CHANNEL, // your agora channel
        token: TOKEN, // use null or skip if using app in testing mode,
        width: 100, // Width of the local video view
        height: 400, // Height of the local video
    };
    const callbacks = {
        EndCall: () => setVideoCall(false),
    };


    return (
        <MainLayouts>

            <br />


            {
                videoCall ? (
                    // <div style={{ display: 'flex', width: '100%', height: '100vh', textAlign: "center" }}>
                    //     <div style={{ display: 'flex', width: '100%', height: '100%', textAlign: "center" }}>
                    //         <AgoraUIKit rtcProps={rtcProps} callbacks={callbacks} />
                    //     </div>
                    // </div>
                    <div style={{ padding :"0 300px", display: 'grid', height: '90vh', width: '100vw' }}>
                        <AgoraUIKit rtcProps={rtcProps} callbacks={callbacks} />
                    </div>
                ) : (
                    <Button type='primary' onClick={() => setVideoCall(true)}>Start Call</Button>
                )
            }


         

        </MainLayouts >
    )
}

export default AgoraVideoCall